// extracted by mini-css-extract-plugin
export default {"giftCardsContainer":"giftCardsContainer__2Pe8E","tooltip":"tooltip__KlvV5","tooltipContent":"tooltipContent__3JmDK"};
    if(module.hot) {
      // 1788784384848
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  